console.log('✅ scroll-to-top.js loaded successfully!');


import { navigateTo } from '../../js/router-navigator.js';
import { appState } from '../../js/state.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

export async function buildComponentNotAuthorizedLoginRedirectStore() {
  console.log(
    `🔄 Building Component: buildComponentNotAuthorizedLoginRedirect - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    

      const html = `
          

        `;

    //const html = `
    //      <div> You are not authorised! </div>

    //    `;

      console.log('✅ NotAuthorizedLoginRedirect built successfully.');

    // Register event listeners
      registerEventListenerToAttach(initbuildComponentNotAuthorizedLoginRedirectStore);

    return html;
  } catch (err) {
      console.error('❌ Error building NotAuthorizedLoginRedirect:', err);
      return '<div>NotAuthorizedLoginRedirect could not be loaded.</div>';
  }
}



// protected override void OnInitialized()
//{
      
      


//        string linkLogin = _myUserIdentityInformationService.SiteLanguageCookie + "/" + StaticLinksTranslations.LinkKeySignIn(_myUserIdentityInformationService.SiteLanguageCookie);
                        


//        string baseUrl = _navigationManager.BaseUri;
//        string returnUrl = _navigationManager.Uri;

//        string returnUrlX = returnUrl.Replace(baseUrl, "");

//        // _navigationManager.NavigateTo($"/login?key={key}&returnAddress={returnUrl}", true);

//        string fullUrl = linkLogin + "?returnUrl=" + returnUrlX;

//    _navigationManager.NavigateTo(fullUrl, true);
//}






export async function initbuildComponentNotAuthorizedLoginRedirectStore() {
  try {

    //  alert('🔄 Initializing NotAuthorizedLoginRedirect component...');


      const { loadMyTranslationsService } = await import(
          /* webpackChunkName: "translation-service" */
          /* webpackPrefetch: true */
          '../../services/my-translator-service.js'
      );

      const {
         // _tempTextTranslator: tTexts,
          _tempLinksTranslator: tLinks,
         // _tempFragmentsTranslator: tFrags
      } = await loadMyTranslationsService(appState.SiteLanguageCookie);


      const [{ navigateTo }] = await Promise.all([
          import(
      /* webpackChunkName:"router-navigator" */ '../../js/router-navigator.js'
          ),
      ]);

      if (appState.MyUserIsAuthenticated  && appState.MyBuyingEntityType === "Business") {

         //  console.log('✅ User is authenticated, no need to redirect.');
          return;


      }



      //get current url
      const currentUrl = window.location.href;
      //const returnUrl = encodeURIComponent(currentUrl);
      const returnUrl = currentUrl;


      const linkLogin = tLinks.keySignIn + `?returnUrl=${returnUrl}`;

      navigateTo(linkLogin);


      console.log('✅ NotAuthorizedLoginRedirect listeners attached.');
  } catch (error) {
      console.error('❌ Error attaching NotAuthorizedLoginRedirect listeners:', error);
  }
}
